import { RootAppState } from 'store/configureStore'

export const projectEstimatedDeliveryDaysSelector = (state: RootAppState) => {
  return state.project.activeProject?.deliveryEstimation
}
